// payoutmanagement/PayoutManagementView.jsx — 정산 관리 메인 렌더 뷰
// 상단: 달력 (날짜별 인원·금액·엑셀 다운로드)
// 하단: 정산입금 목록 (날짜 내림차순, 행 클릭 → 계좌/세금정보 편집)

import React from 'react';
import { PayoutCalendar } from './PayoutCalendar';
import { PayoutList }     from './PayoutList';
import { EditRecordModal } from './EditRecordModal';
import { stdHeaderRow, stdPageTitle, stdPageSubtitle, stdOutlineBtn, STD_HEADER_TOP } from '../adminlayout/designStandard';

export function PayoutManagementView(props) {
  const {
    isMobile, // companyCode 는 제목 접미사에만 쓰였다 — 접미사를 뺐으므로 받지 않는다 (2026-09-14)
    // 달력
    month, prevMonth, nextMonth, calendarData,
    selectedDate, setSelectedDate,
    // 목록
    listData, listLoading, taxTypeEnabled,
    // 은행코드 (자동완성용 활성 목록)
    bankCodes,
    // 편집 모달
    editModal, openEditModal, closeEditModal,
    bankAccounts, taxInfoList,
    linkRecord, addBankAccount, addTaxInfo, deleteBankAccount, deleteTaxInfo,
    // 엑셀
    downloadExcel,
    downloadPrepayExcel,
    // 새로고침
    refresh,
  } = props;

  // ── 스타일 ──────────────────────────────────────────────────────────────────
  // 헤더는 디자인 표준 텍스트 헤더(stdHeaderRow) 사용 — 상단 여백은 stdHeaderRow 가 처리 (2026-08-27 통일)
  const pageSt = {
    display: 'flex', flexDirection: 'column', gap: 16,
    // 휴대폰은 공통 틀(AdminLayout main)이 좌우 16px 을 준다 — 겹치지 않게 0 (2026-09-28)
    padding: isMobile ? '12px 0' : '0 24px 20px',
    maxWidth: 1100, margin: '0 auto', width: '100%',
  };
  const btnSt = {
    border: '1px solid var(--border)', borderRadius: 8, padding: '6px 14px',
    fontSize: 12, fontWeight: 600, cursor: 'pointer',
    background: 'var(--bg-card)', color: 'var(--text)',
  };

  // 회사명 표시

  // 선택된 날짜 필터 해제 버튼
  const hasDateFilter = !!selectedDate;

  return (
    <div style={pageSt}>

      {/* ── 헤더: 표준 텍스트 헤더 (제목·부제 + 보조 버튼) ── */}
      <div style={{ ...stdHeaderRow(isMobile), margin: isMobile ? '4px 0 0' : `${STD_HEADER_TOP}px 0 0` }}>
        <div>
          {/* 제목에 회사 접미사를 붙이지 않는다 (2026-09-14) — 상단 작업대상 선택창이 알려준다. */}
          <h2 style={stdPageTitle}>정산 관리</h2>
          <div style={stdPageSubtitle}>정산 지급 내역을 관리합니다.</div>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          <button style={stdOutlineBtn} onClick={refresh}>새로고침</button>
        </div>
      </div>

      {/* ── 달력 ── */}
      <PayoutCalendar
        month={month}
        prevMonth={prevMonth}
        nextMonth={nextMonth}
        calendarData={calendarData}
        downloadExcel={downloadExcel}
        downloadPrepayExcel={downloadPrepayExcel}
        isMobile={isMobile}
      />

      {/* ── 날짜 필터 표시 ── */}
      {hasDateFilter && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: 'rgba(37,99,235,0.06)', borderRadius: 8, border: '1px solid rgba(37,99,235,0.15)' }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: '#2563eb' }}>{selectedDate} 필터</span>
          <button style={{ ...btnSt, fontSize: 11, padding: '3px 10px' }} onClick={() => setSelectedDate(null)}>해제</button>
        </div>
      )}

      {/* ── 정산 목록 ── */}
      <PayoutList
        listData={listData}
        listLoading={listLoading}
        openEditModal={openEditModal}
        selectedDate={selectedDate}
        isMobile={isMobile}
        taxTypeEnabled={taxTypeEnabled}
      />

      {/* ── 계좌/세금정보 편집 모달 ── */}
      {editModal && (
        <EditRecordModal
          record={editModal}
          bankAccounts={bankAccounts}
          taxInfoList={taxInfoList}
          bankCodes={bankCodes}
          onLink={linkRecord}
          onAddBankAccount={addBankAccount}
          onAddTaxInfo={addTaxInfo}
          onDeleteBankAccount={deleteBankAccount}
          onDeleteTaxInfo={deleteTaxInfo}
          onClose={closeEditModal}
          taxTypeEnabled={taxTypeEnabled}
        />
      )}
    </div>
  );
}
